// extracted by mini-css-extract-plugin
export default {"title":"MessageFailure_title__WlqPP","subTitle":"MessageFailure_subTitle__RP65S"};